import React from 'react';
import PropTypes from 'prop-types';

import './SearchResultsBlock.scss';
import api from 'js/api-helper';
//import cn from 'classnames';

class SearchResultsBlock extends React.Component {
    static propTypes = {
        title: PropTypes.string,
        searchTerm: PropTypes.string,
        pageIndex : PropTypes.number,
        pagesCount: PropTypes.number,
        pageSize: PropTypes.number,
        totalItemsCount: PropTypes.number,
        numberHitsText: PropTypes.string,
        baseUrl: PropTypes.string,
        pagerLabels: PropTypes.shape({
            prevButton: PropTypes.string,
            nextButton: PropTypes.string,
        }),
        results: PropTypes.arrayOf(PropTypes.shape({
            title: PropTypes.string,
            url: PropTypes.string,
            ingress: PropTypes.string,
            date: PropTypes.string,
            categories: PropTypes.string,
            trackUrl: PropTypes.string,
        })),
        noResults: PropTypes.object,
        inputPlaceholder: PropTypes.string
    }

    render() {
        const {
            title,
            searchTerm,
            pageIndex,
            pagesCount,
            totalItemsCount,
            numberHitsText,
            results,
            baseUrl,
            inputPlaceholder,
            pagerLabels,
        } = this.props;

        const handleLinkClick = (trackUrl, e) => {
            if (trackUrl) {
              var defaultBehaviour = e.ctrlKey;
              if (!defaultBehaviour) {
                e.preventDefault();
              }
              var href = e.currentTarget.href;
              api.execute(trackUrl, {}).then(_response => {
                if (!defaultBehaviour) {
                  window.location.href = href;
                }
              });
            }
        };

        const maxVisiblePagesAmount = 5;
        const pagesAmount = pagesCount;
        const currentPageIndex = pageIndex;

        const allPagesAreVisible = maxVisiblePagesAmount >= pagesAmount;
        const visibilityRange = Math.floor(maxVisiblePagesAmount / 2);
        const leftBoundary = currentPageIndex <= visibilityRange + 1;
        const rightBoundary = currentPageIndex >=  pagesAmount - visibilityRange;

        var paginationChildren = [];

        for (let pageIndex = 1; pageIndex < pagesAmount + 1; pageIndex++){
            let visible = false;

            if(allPagesAreVisible){
                visible = true;
            }
            else if(leftBoundary){
                
                visible = pageIndex <= maxVisiblePagesAmount;
            }
            else if(rightBoundary){
                visible = pageIndex > pagesAmount - maxVisiblePagesAmount;
            }
            else {
                visible = Math.abs(currentPageIndex - pageIndex) <= visibilityRange;
            }

            let li;

            if (visible) {

                li = <li key={pageIndex} className="pagination__item">
                    {pageIndex === currentPageIndex ?
                        <span className="pagination__button pagination__button_active">{pageIndex}</span>
                        :
                        <a href={baseUrl + "?query=" + searchTerm + "&page=" + pageIndex } className="pagination__button">{pageIndex}</a>
                    }
                </li>;
            }

            paginationChildren.push(li);
        }

        return (
            <div className="search-results-block">
                <div className="search-container">
                    <h1>{title}</h1>
                    <div className="search-form">
                        <form className="search-form-wrapper" method="get" action={baseUrl} ><input type="text" placeholder={inputPlaceholder} id="search-results-form" name="query" /></form>
                    </div>
                    {totalItemsCount > 0 && (
                        <div className="search-container-hits-text">
                            {numberHitsText}
                        </div>
                    )}
                </div>
                <div className="results-container">
                    <div className="results-content">
                        {(totalItemsCount > 0) && (
                            <ul className="results">
                                {results.map((result, index) => (
                                    <li key={index}>
                                        <a href={result.url} onClick={(e) => handleLinkClick(result.trackUrl, e)}><h2>{result.title}</h2></a>
                                        <p className="ingress">{result.ingress}</p>
                                        <p>{result.type} | {result.businessArea}</p>
                                        <div className="last-updated">
                                            {result.date}<br />
                                            {result.categories}
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        )}
                        {(pagesCount > 1) && (
                            <ul className="pagination pagination_in-search-block">
                                {!allPagesAreVisible && !leftBoundary && (
                                    <li className="pagination__item pagination__item_prev" >
                                        <a href={baseUrl + "?query=" + searchTerm + "&page=" + (pageIndex-1) } className="pagination__button pagination__button_prev" aria-label={pagerLabels && pagerLabels.prevButton ? pagerLabels.prevButton : null}></a>
                                        <div className="pagination__button-dots">...</div>
                                    </li>
                                )}
                                {paginationChildren}
                                {!allPagesAreVisible && !rightBoundary && (
                                    <li className="pagination__item pagination__item_next" >
                                        <div className="pagination__button-dots">...</div>
                                        <a className="pagination__button pagination__button_next" href={baseUrl + "?query=" + searchTerm + "&page=" + (pageIndex+1)} aria-label={pagerLabels && pagerLabels.nextButton ? pagerLabels.nextButton : null}></a> 
                                    </li>
                                )}
                            </ul>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default SearchResultsBlock;



// WEBPACK FOOTER //
// ./src/components/SearchResultsBlock/SearchResultsBlock.jsx